import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import Api from '#services/api'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'
import Avatar from '#components/a/Avatar'
import TagList from '#components/m/TagList'
import AbteilungenVerwaltenModal from '../../m/AbteilungenVerwaltenModal'
import RemoveAusbilderModal from '#components/m/MeineOrganisation/RemoveAusbilderModal'

const abteilungsTags = abteilungen =>
  abteilungen.map(a => ({
    name: a.name,
    color: a.backgroundColor,
    contrastingTextColor: a.textColor,
  }))

const noAbteilungenPlaceholder = () => (
  <div className="meine-ausbilder__no-abteilungen-placeholder">
    {i18n.t('meine_ausbilder_no_abteilungen_placeholder')}
  </div>
)

const saveAbteilungen = async ({ausbilderId, abteilungenIds}) => {
  await Api.updateAusbilderAbteilungen(ausbilderId, abteilungenIds)
  actions.meineAusbilder.getUserAusbilder()
}
export function AusbilderRow(props) {
  const {ausbilder} = props
  const haveAbteilungen = ausbilder.abteilungen && ausbilder.abteilungen.length > 0

  return (
    <tr data-testid={`ausbilder-${ausbilder.id}`}>
      <td>
        <div>
          <Avatar profileImage={ausbilder.profileImage} />
          <TriggerWithTooltip text={`${ausbilder.lastname}, ${ausbilder.firstname}`} modifiers={['dark', 'nopadding']}>
            <span>{`${ausbilder.lastname}, ${ausbilder.firstname}`}</span>
          </TriggerWithTooltip>
        </div>
      </td>

      <td>
        <div>
          <TriggerWithTooltip text={ausbilder.markt} modifiers={['dark', 'nopadding']}>
            <span>{ausbilder.markt}</span>
          </TriggerWithTooltip>
        </div>
      </td>
      <td>
        <div>
          {haveAbteilungen || noAbteilungenPlaceholder()}
          {haveAbteilungen && <TagList tags={abteilungsTags(ausbilder.abteilungen)} />}
          <AbteilungenVerwaltenModal
            ausbilder={ausbilder}
            triggerButtonModifier="meine-ausbilder__abteilungen-verwalten"
            handleSave={saveAbteilungen}
          />
        </div>
      </td>
      <td>
        <RemoveAusbilderModal ausbilder={ausbilder} />
      </td>
    </tr>
  )
}

AusbilderRow.propTypes = {
  ausbilder: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    markt: PropTypes.string,
    profileImage: PropTypes.string,
    abteilungen: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        backgroundColor: PropTypes.string,
        textColor: PropTypes.string,
      }),
    ),
  }),
}
